import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Bearer-token fallback (works even when third-party/secure cookies are blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tcc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("tcc_token", token);
}
export function clearToken() {
  localStorage.removeItem("tcc_token");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}


// SPK OCR runs as a background job (long multi-page SPKs exceed the 60s gateway limit)
export async function runSpkOcr(file) {
  const fd = new FormData(); fd.append("file", file);
  const { data } = await api.post("/claims/ocr-async", fd);
  for (let i = 0; i < 120; i++) {
    await new Promise((r) => setTimeout(r, 2500));
    const { data: j } = await api.get(`/claims/ocr-async/${data.job_id}`);
    if (j.status === "DONE") return j.result;
    if (j.status === "ERROR") { const e = new Error(j.error); e.response = { data: { detail: j.error } }; throw e; }
  }
  const e = new Error("OCR timeout"); e.response = { data: { detail: "OCR terlalu lama — coba lagi" } }; throw e;
}
